import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MethodologyComponent } from './main/methodology/methodology.component';
import { PartnersComponent } from './main/partners/partners.component';
import { ReviewComponent } from './main/review/review.component';
import { HomeComponent } from './main/home/home.component';
import { CareerComponent } from './main/career/career.component';
import { ContactComponent } from './main/contact/contact.component';
import { DisclaimerComponent } from './main/disclaimer/disclaimer.component';
import { FaqComponent } from './main/faq/faq.component';
import { SalesforceComponent } from './main/salesforce/salesforce.component';


const routes: Routes = [
  { path: '', component: HomeComponent, pathMatch:'prefix'},
  { path: 'home', component: HomeComponent},
  { path: 'methodology', component: MethodologyComponent },
  { path: 'association', component: PartnersComponent },
  { path: 'review', component: ReviewComponent },
  
  { path: 'careers', component: CareerComponent },
  { path: 'careers/:id', component: CareerComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'contact/:id', component: ContactComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'disclaimer', component: DisclaimerComponent },

  { path: 'salesforce', component: SalesforceComponent },
  { path: 'salesforce/:id', component: SalesforceComponent },
  {
    path: 'offerings',
    loadChildren: () => import('./main/offerings/offerings.module').then(m => m.OfferingsModule)
  },
  { path: 'service', 
    loadChildren: () => import('./main/services/services.module').then(m => m.ServicesModule)
  },
  { path: 'cloud', 
    loadChildren: () => import('./main/cloud/cloud.module').then(m => m.CloudModule)
  },
  { path: 'about', 
    loadChildren: () => import('./main/about/about.module').then(m => m.AboutModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
